import React from 'react';
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import {Button, Col, Container, Row, Form} from "react-bootstrap";

import {authenticationService} from "../service/autenticationService";

class Login extends React.Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            currentUser:null,
            username:'',
            password:'',
            errorMessage:'invalid login!',
            validated:false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    // handleInputChange = function (event) {
    //     console.log('yippe', event.target.value);
    //     const target = event.target;
    //     const value = target.type === 'checkbox' ? target.checked : target.value;
    //     const name = target.name;
    //     var newState = {};
    //     newState[name] = value;
    //     this.setState(newState);
    //     console.log("name:" + name + " value:" + value, this.state);
    // }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };


    // mimicing API request
    doLogin = (username,password) => authenticationService.login(username, password);

    handleSubmit = async function(event) {
        event.preventDefault();
        event.stopPropagation();
        let success = await this.doLogin(this.state.username, this.state.password).then( (user) => {
                console.log("ahhh.." + JSON.stringify(user));
                if (user != null) {
                    return true;
                }
                return false;
            }
        )
        if(success){
            this.props.history.push("harness/summary");
        }else{
            console.log("bad pass");
        }
    }

    render() {
        return (
            <Container style={{"margin":"100px 0 0 0"}}>
                <Row>
                    <Col>
                        <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmit}>
                            <Form.Group as={Row} controlId="username">
                                <Form.Label column sm="2">
                                    Username
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control name="username" onChange={this.handleChange}/>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="password">
                                <Form.Label column sm="2">
                                    Password
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control type="password"  name="password" onChange={this.handleChange} />
                                </Col>
                            </Form.Group>
                            <Button type="submit">Login</Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
        );
    }
}

const LoginWithRouter = withRouter(Login)

export {LoginWithRouter}
